import { AppsListRegular, QuestionCircleRegular } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";

interface HeadingProps {
  categoryName: string;
  subcategoriesCount: number;
  questionsCount: number;
}

function Heading({
  categoryName,
  subcategoriesCount,
  questionsCount,
}: HeadingProps) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-2">
      <div className="text-2xl font-bold">{categoryName}</div>
      <div className="flex gap-6">
        <div className="flex gap-1">
          <AppsListRegular fontSize={20} />
          <div className="text-cool-gray-600">
            {subcategoriesCount} {t("sub-category-counter")}
          </div>
        </div>
        <div className="flex gap-1">
          <QuestionCircleRegular fontSize={20} />
          <div className="text-cool-gray-600">
            {questionsCount} {t("question-counter")}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Heading;
